import React from 'react';
import { useLang } from '@/i18n/LangContext';

export default function HowWeWork() {
  const { t } = useLang();
  return (
    <div data-testid="how-page">
      <section className="mm-section dark" style={{ paddingTop: 72 }}>
        <div className="container-mm">
          <div className="eyebrow">{t.home.how_eyebrow}</div>
          <h1 style={{ fontSize: 'clamp(48px, 6vw, 96px)', marginTop: 16, color: 'var(--mm-ivory)' }}>{t.home.how_title}</h1>

          <div className="mm-process" style={{ marginTop: 64 }}>
            {t.steps.map((s, i) => (
              <div className="mm-step" key={i} data-testid={`how-step-${i+1}`}>
                <div className="num">STEP · {String(i + 1).padStart(2, '0')}</div>
                <h4>{s.t}</h4>
                <p>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
